// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.common with an alias.
require('@babel/polyfill');
import Vue from 'vue';
import App from './app.vue';
import Vue2Filters from 'vue2-filters';
import router from './router';
//import vuetify from '@/vuetify';
import * as config from './shared/config/config';
import InfiniteLoading from 'vue-infinite-loading';
import AccountService from './shared/service/account.service';
import ConfigurationService from '@/shared/service/configuration.service';

import '../content/scss/vendor.scss';
import TranslationService from '@/shared/service/translation.service';
import * as tmczVueUiConfig from './shared/config/config-tmcz-vue-ui';
import '@tmcz/tmcz-vue-ui/dist/tmcz-vue-ui.css';
import { AA_SUSPEND_COOKIE_NAME } from '@/shared/constants';

/* tslint:disable */

/* tslint:enable */
Vue.config.productionTip = false;
config.initVueApp(Vue);
config.initFortAwesome(Vue);
tmczVueUiConfig.init(Vue);
Vue.use(Vue2Filters);
Vue.component('infinite-loading', InfiniteLoading);

const i18n = config.initI18N(Vue);
export const store = config.initVueXStore(Vue);

const configurationService = new ConfigurationService(store);
const translationService = new TranslationService(store, i18n);
const accountService = new AccountService(store, translationService, router);

function processRouter(to, from, next) {
  if (to.meta && to.meta.authorities && to.meta.authorities.length > 0) {
    if (!accountService.hasAnyAuthority(to.meta.authorities)) {
      next('/forbidden');
    } else {
      next();
    }
  } else {
    // no authorities, so just proceed
    next();
  }
}

function checkAccount(to, from, next) {
  accountService
    .retrieveAccountPromise()
    .then(result => {
      if (result.data) {
        accountService.retrieveAccountSuccess(result.data);
        const { requiredLogin2F, loginMethod2F } = result.data;
        // console.log(requiredLogin2F, loginMethod2F);
        if (requiredLogin2F === 'N' || (requiredLogin2F === 'Y' && loginMethod2F)) {
          // console.log('login', to);
          if (store.getters.embed) {
            // console.log('login parameter - posting message to parent');
            window.parent.postMessage('tau:login', '*');
          }
        }
      } else {
        accountService.retrieveAccountFailure();
      }
      processRouter(to, from, next);
    })
    .catch(error => {
      accountService.retrieveAccountFailure();
      processRouter(to, from, next);
    });
}

// lifecycle hook - ensure AA authentication check and check authorities
router.beforeEach((to, from, next) => {
  if (!to.matched.length) {
    next('/not-found');
  }

  if (to.query.embed === '1') {
    store.commit('setEmbed', true);
  }
  if (to.query.embed === '0') {
    store.commit('setEmbed', false);
  }

  // Process AA authentication before router entered
  if (to.path === '/first-login') {
    processRouter(to, from, next);
  } else {
    checkAccount(to, from, next);
  }
});

/* tslint:disable */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  router,
  provide: {
    translationService: () => translationService,
    accountService: () => accountService,
    configurationService: () => configurationService
  },
  i18n,
  store
  //vuetify
});
